interface EducationProps {
  education: {
    id: number;
    institution: string;
    degree: string;
    graduationYear: string;
    highlights: string[];
  };
}

function Education({ education }: EducationProps) {
  return (
    <div
      key={education?.id}
      className="bg-[#1a1a1d] shadow-md rounded-lg hover:shadow-lg transition-shadow mb-3 pb-5"
    >
      <div className="flex justify-between items-center ">
        <div className="lg:min-w-3/5 lg:h-12 pb-0.5 pr-1 bg-[#016e86] border-b-2 border-[#1cd5ff] rounded-r-3xl  flex items-center justify-center">
          <h3 className="lg:text-xl font-bold text-gray-100 text-left p-2 ">
            {education.degree}
          </h3>
        </div>

        <span className="text-gray-400 text-sm px-6">
          {education.graduationYear}
        </span>
      </div>
      <p className="text-white mt-2 mb-2 text-left md:text-center font-medium px-10 ">
        {education.institution}
      </p>
      {education.highlights && (
        <ul className="list-disc list-inside text-gray-400 text-left md:text-center px-10 ">
          {education.highlights.map((highlight, idx) => (
            <li key={idx} className="mb-1">
              {highlight}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default Education;
